function siteCatalystAjax(s, events) {
  if (!s) return; // The `s` object does not exists: stop here

  // A flag to prevent the run() function to be called twice
  let contentWritten = false;

  // A counter that will allow to call the run() function after all the
  // event requests are done.
  let ajaxCounter = 0;

  // Write the content
  function run() {
    if (contentWritten) return;

    contentWritten = true;
  }

  // Ajax calls
  function request(event) {
    $.ajax({
      url: event.url,
      dataType: 'text',
      success: function(data) {
        event.successCallback(data);
        if (++ajaxCounter >= events.length) run();
      },
      error: function() {
        event.errorCallback();
        if (++ajaxCounter >= events.length) run();
      },
      method: 'GET'
    });
  }

  // Launch the requests
  for (let i = 0, len = events.length; i < len; i++) {
    request(events[i]);
  }
}
  
module.exports = siteCatalystAjax;
